{
  "categorale_instellingen": "Categorale instellingen",
  "effluent": "Effluentleidingen",
  "gl_wk_bu": "Aardgasvrije wijken en buurten",
  "ggz": "Geestelijke gezondheidszorg",
  "ghz": "Gehandicaptenzorg",
  "poliklinieken": "Poliklinieken",
  "rioolleidingen": "Rioolleidingen",
  "rwzis": "Rioolwaterzuiveringen",
  "schoolsNPO": "Scholen overig",
  "schoolsPO": "Scholen PO",
  "skating": "IJsbanen",
  "sports": "Sportaccomodaties",
  "swimming": "Zwembaden",
  "tvw": "Transitievisie Warmte",
  "vvt": "Verpleeghuizen, verzorging en thuiszorg",
  "warmtenetten_nbr_infra": "Warmtenetten N-Brabant - infrastructuur",
  "warmtenetten_nbr_lokaal": "Warmtenetten N-Brabant - lokale netten",
  "wateren_potentie_gt1ha": "Oppervlaktewater potentie (TEO)",
  "wko_diepte": "WKO restrictie: Diepte",
  "wko_gbes": "WKO gesloten bodemenergiesystemen",
  "wko_gwi": "WKO grondwaterinfiltratie",
  "wko_gwio": "WKO grondwaterinfiltratie en -onttrekking",
  "wko_gwo": "WKO grondwateronttrekking",
  "wko_installaties": "WKO installaties",
  "wko_natuur": "WKO restrictie: Natuur",
  "wko_obes": "WKO open bodemenergiesystemen",
  "wko_ordening": "WKO restrictie: Ordening",
  "wko_specprovbeleid": "WKO restrictie: SpecProvBeleid",
  "wko_verbod": "WKO restrictie: Verbod",
  "wn_vf_almere": "Warmtenet Almere (Vattenfall)",
  "wn_vf_amsterdam": "Warmtenet Amsterdam (Vattenfall)",
  "wn_vf_arnhem": "Warmtenet Arnhem (Vattenfall)",
  "wn_vf_ede": "Warmtenet Ede (Vattenfall)",
  "wn_vf_leiden": "Warmtenet Leiden (Vattenfall)",
  "wn_vf_lelystad": "Warmtenet Lelystad (Vattenfall)",
  "wn_vf_nijmegen": "Warmtenet Nijmegen (Vattenfall)",
  "wn_vf_rotterdam": "Warmtenet Rotterdam (Vattenfall)",
  "wn_vf_vlieland": "Warmtenet Vlieland (Vattenfall)",
  "wzv": "Woonzorgvisies", 
  "ziekenhuizen_rk": "Ziekenhuizen"
}
